<!--本页为tab标签-->
<template>

    <el-tabs
            v-model="editableTabsValue"
            type="card"
            closable
            @tab-remove="removeTab($event)"
            @tab-click="handleClickTab($event.name)"
            
    >
        <el-tab-pane
                :key="item.name"
                v-for="item in this.$store.getters.openedTabList"
                :label="change_Zh(item.name)"
                :name="item.componentName"
        >
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";

    const {mapState, mapMutations, mapGetters} = createNamespacedHelpers("table");
    export default {
        name: 'navMain',
        data() {
            return {
                editableTabsValue: 'User',
                editableTabs: [{
                    title: this.$t('title.userList'),
                    name: 'User'
                }],
                tabIndex: 1,
                openedTabList: [{componentName:'User',name:this.$t('title.userList')}]
            }
        },
        methods: {
            ...mapMutations(["ADD_TABLE", "CHANGE_TABLE", "DELETE_TABLE"]),
            handleClickTab(route) {
                this.CHANGE_TABLE(route)
                this.$router.push(route)
            },
            removeTab(targetName) {
                // 首页不允许被关闭（为了防止el-tabs栏中一个tab都没有）
                // if (targetName === 'index') {
                //   return false
                // }
                let tabs = this.editableTabs
                let activeName = this.editableTabsValue
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1]
                            if (nextTab) {
                                activeName = nextTab.name
                            }
                        }
                    })
                }
                this.DELETE_TABLE(targetName)
                // let deductIndex = this.openedTabList.indexOf(targetName)


                let tabNum = 0
                this.openedTabList.forEach((item, index, self) => {
                    if (item.componentName == targetName) {
                        tabNum = index
                    }
                })
                this.openedTabList.splice(tabNum, 1)
                this.$router.push(activeName)
                this.editableTabsValue = activeName
                this.editableTabs = tabs.filter(tab => tab.name !== targetName)
                if (this.openedTabList.length === 0) {
                    this.ADD_TABLE({name: this.$t('title.userList'), componentName: 'User'})
                    this.$router.push('User')
                }
            }
        },
        
        computed: {
            watchOpenedTabList() {
                
                return this.$store.getters.openedTabList

            },
            watchChangeTab() {
                return this.$store.getters.activeTab
            }
        },
        watch: {
            watchOpenedTabList(val) {
                if (val.length > this.openedTabList.length) {
                    // 添加了新的tab页
                    // 导致$store.state中的openedTab长度
                    // 大于
                    // 标签页中的openedTab长度
                    // 因此需要新增标签页
                    let newTab = val[val.length - 1] // 新增的肯定在数组最后一个
                    ++this.tabIndex
                    this.editableTabs.push({
                        title: newTab.name,
                        name: newTab.componentName,
                    })
                    this.editableTabsValue = newTab.componentName
                    this.openedTabList.push({name: newTab.name, componentName: newTab.componentName})
                    //  this.$router.push(newTab.componentName)
                } else {
                    // this.openedTabList = val
                }
            },
            watchChangeTab(val) {
                // 监听activetab以实现点击左侧栏时激活已存在的标签
                if (val !== this.editableTabsValue) {
                    this.editableTabsValue = val
                }
            }
        },
        created() {
            // 刷新页面时（F11)
            // 因为<router-view>的<keep-alive>，会保留刷新时所在的router
            // 但是tab标签页因为刷新而被重构了，tab没有了
            // 因此需要将router回到index
            this.$router.push('User')
        }
    }
</script>

<style scoped>
   
</style>
